import _ from "lodash";

function getActiveOpportunities({ mappedOpportunities }) {
  return mappedOpportunities.filter((opportunity) => opportunity.isActive);
}

function getInactiveOpportunities({ mappedOpportunities }) {
  return mappedOpportunities
    .filter((opportunity) => !opportunity.isActive)
    .map((opportunity) => ({ ...opportunity, onShareOpportunity: () => {} }));
}

export function getDifferentiatedOpportunities({
  rawOpportunities,
  onShareOpportunity
}) {
  const mappedOpportunities = rawOpportunities.map((opportunity) => ({
    ...opportunity,
    name: opportunity.product.name,
    thumbnailUrl: opportunity.product.images[0].url,
    price: opportunity.product.price ? opportunity.product.price : 0,
    influencerCount: opportunity.stats.influencers,
    applicantCount: opportunity.stats.applicants,
    videoCount: opportunity.stats.videos,
    viewCount: opportunity.stats.views,
    salesMade: opportunity.stats.earnings,
    onShareOpportunity: () => onShareOpportunity(opportunity)
  }));
  const activeOpportunities = getActiveOpportunities({ mappedOpportunities });
  const inactiveOpportunities = getInactiveOpportunities({
    mappedOpportunities
  });
  return {
    activeOpportunities,
    inactiveOpportunities
  };
}

export function buildGetOpportunitiesVariables({ filters }) {
  const variables = {
    id: undefined,
    createdAt: {},
    product: undefined
  };

  const filterKeys = Object.keys(filters);

  filterKeys.forEach((key) => {
    if (key === "createdAt") {
      variables[key] = {
        ...variables[key],
        greaterThan: new Date(filters[key][0]).toUTCString(),
        lessThan: new Date(filters[key][1]).toUTCString()
      };
    } else if (key === "product") {
      variables[key] = {
        id: filters[key].key
      };
    } else {
      variables[key] = {
        ...variables[key],
        equals: filters[key].label
      };
    }
  });

  return {
    variables,
    fetchPolicy: "network-only"
  };
}

export function buildFilterOptions({ opportunities }) {
  const mappedOpportunities = !opportunities
    ? []
    : opportunities.map((opportunities) => ({
        ...opportunities,
        productName: opportunities.product.name
      }));

  return [
    {
      key: "product",
      label: "Product Name",
      type: "menu",
      options: _.uniqBy(mappedOpportunities, "productName").map((o) => ({
        key: o.product.id,
        label: o.product.name
      })),
      filter: true
    }
  ];
}

export function getColumnWidth({ columnWidths, index, width }) {
  return (
    columnWidths[index] ||
    ((index === 0 && 0.2 * width) ||
      (index === 1 && 0.13 * width) ||
      (0.67 / 8) * width)
  );
}

export const onColumnResizeHof = ({
  columnWidths,
  setColumnWidths,
  columns
}) => ({ column, width }) => {
  const index = columns.findIndex((c) => c.key === column.key);
  const newWidths = columnWidths;
  newWidths[index] = width;

  setColumnWidths(newWidths);
};
